import type { PrintNumberFormat } from '../interfaces/PrintNumberFormat'

/** Matches default mask `#,###.##` until bootstrap passes tenant config. */
export const DEFAULT_PRINT_NUMBER_FORMAT: PrintNumberFormat = {
  group: ',',
  decimal: '.',
  fractionDigits: 2
}

export const DEFAULT_PRINT_CURRENCY = 'EUR'
